export const noUserFound = (state) => state.users.length === 0

export const paramsForBackend = (state) =>
  state.isAdvanceSearch ? { query_fields: state.fields } : { query: state.text }
